<template>
  <admin-layout isLayout="admin">
    <div class="container m-2 m-sm-5 mw-100 w-auto">
      <div class="mb-4 w-100 d-flex justify-content-end">
        <b-button
          @click="downloadExcel"
          variant="success"
          :disabled="isDownloadExcel"
        >
          <span class="mr-2">Excel İndir</span>
          <b-icon icon="download"></b-icon>
        </b-button>
      </div>
      <SuggestionHeader
        @search-filter="suggestionSearchFilter"
        @clear-search-filter="clearSearchFilter"
        @continuity-tracking-list="continuityTrackingBulkListModal($event)"
        :totalIdea="productizationTotalRecords"
        suggestionTypeId="3"
        @order-data="orderData"
        location="otoProduct"
      />
      <div class="row">
        <AdminTable
          :columns="columns"
          :rows="getProductizationData"
          @table-detail="cardDetail($event)"
          location="otoProduct"
          isLayout="Admin"
        />
        <div
          class="row mt-4 d-flex align-items-center justify-content-center w-100"
        >
          <b-pagination
            v-model="currentPage"
            :total-rows="productizationTotalRecords"
            :per-page="perPage"
            aria-controls="my-table"
          ></b-pagination>
        </div>
      </div>
      <div class="row text-right d-flex align-items-center justify-content-end">
        <span class="text-black-50 font-weight-bold"
          >Toplam:{{ productizationTotalRecords }} Adet</span
        >
      </div>
      <transition name="fade">
        <ProductizationOtoModal
          :detailData="productizationItem"
          :searchFilterData="searchFilterData"
          isLayout="Admin"
          v-if="isProductization"
          @close="isProductization = $event"
        />
        <ContinuityTrackingBulkModal
          v-if="isContinuityTrackingBulkEvaluation"
          :totalRecords="totalRecords"
          :continuityTrackingList="getContinuityTrackingList"
          :title="title"
          @save-continuity-tracking-bulk="saveContinuityTrackingBulkList"
          @get-continuity-tracking-paged-list="getContinuityTrackingPagedList"
          @close="isContinuityTrackingBulkEvaluation = $event"
        />
      </transition>
    </div>
  </admin-layout>
</template>

<script>
import { mapGetters } from "vuex";
import { saveAs } from "file-saver";
import { sortDate, lowerCaseKeys } from "../../helpers";
import { suggestionRdService, upload } from "../../services";

import AdminLayout from "../../layouts/AdminLayout.vue";
import SuggestionHeader from "../../components/Admin/SuggestionHeader";
import AdminTable from "../../components/Admin/AdminTable.vue";
import ProductizationOtoModal from "../../components/Admin/ProductizationOtoModal.vue";
import ContinuityTrackingBulkModal from "../../components/Admin/ContinuityTrackingBulkModal.vue";
export default {
  name: "Productization",
  data() {
    return {
      title: "PROJE FİKRİ SÜREKLİLİK TAKİBİ",
      isProductization: false,
      isContinuityTrackingBulkEvaluation: false,
      productizationItem: null,
      currentPage: 1,
      perPage: 15,
      columns: [
        {
          label: "Fikir No.",
          field: "SuggestionNumber",
          sortable: false,
          thClass: "vgt-center-align",
          tdClass: "vgt-center-align",
        },
        {
          label: "Fikir Sahibi",
          field: "CreatedCustomerName",
          sortable: false,
          thClass: "vgt-center-align",
          tdClass: "vgt-center-align",
        },
        {
          label: "Fikir Tarihi",
          field: "SuggestionDate",
          sortable: false,
          thClass: "vgt-center-align",
          tdClass: "vgt-center-align",
        },
        {
          label: "Proje Adı",
          field: "Title",
          sortable: false,
          thClass: "vgt-center-align",
          tdClass: "vgt-center-align",
        },
        {
          label: "Departman",
          field: "Department",
          sortable: false,
          thClass: "vgt-center-align",
          tdClass: "vgt-center-align",
        },
        {
          label: "Statü",
          field: "SuggestionStatusName",
          sortable: false,
          thClass: "vgt-center-align",
          tdClass: "vgt-center-align",
        },
        {
          label: "",
          field: "action",
          sortable: false,
          thClass: "vgt-center-align",
          tdClass: "vgt-center-align",
        },
      ],
      filterData: null,
      isDownloadExcel: false,
      searchFilterData: null,
    };
  },
  components: {
    AdminLayout,
    SuggestionHeader,
    AdminTable,
    ProductizationOtoModal,
    ContinuityTrackingBulkModal,
  },
  computed: {
    ...mapGetters({
      user: "user/user",
      productizationTotalRecords: "suggestion/productizationTotalRecords",
      totalRecords: "suggestionRD/getContTrackingTotalRecords",
    }),
    getProductizationData() {
      return this.$store.getters["suggestion/getProductizationData"];
    },
    getProductizationIdData() {
      return this.$store.getters["suggestionRD/pagedIdData"];
    },
    getContinuityTrackingList() {
      return this.$store.getters["suggestionRD/getContinuityTrackingList"];
    },
  },
  watch: {
    currentPage() {
      this.searchFilter(this.searchFilterData);
    },
    getProductizationIdData: {
      handler(val) {
        if (val.length > 0) {
          this.routeFilterData();
        }
      },
      immediate: true,
      deep: true,
    },
  },
  async created() {
    await this.searchFilter();
    const route = lowerCaseKeys(this.$route.query);
    if (route.id) {
      await this.$store.dispatch("suggestionRD/setIdData", route.id);
    }
    await this.setContinuityTrackingList();
  },
  methods: {
    clearSearchFilter(event) {
      this.searchFilter(event);
    },
    suggestionSearchFilter(event) {
      this.currentPage = 1;
      this.searchFilter(event);
    },
    async continuityTrackingBulkListModal() {
      await this.setContinuityTrackingList();
      this.isContinuityTrackingBulkEvaluation = true;
    },
    async getContinuityTrackingPagedList(event) {
      this.$store.dispatch("suggestionRD/deleteContinuityTrackingBulkData");
      this.$store.dispatch("suggestionRD/setContinuityTrackingBulkData", event);
    },
    async setContinuityTrackingList() {
      let body = {
        pageSize: 10,
        pageIndex: parseInt(this.currentPage - 1),
        loginUserId: this.user.Data.UserId,
        isAdminPage: true,
        onlyContinuityTrackingSuggestion: true,
      };
      this.$store.dispatch("suggestionRD/setContinuityTrackingBulkData", body);
    },
    async saveContinuityTrackingBulkList(event) {
      let res =
        await suggestionRdService.fetchSaveBulkContinuityTrackingSuggestionRds(
          event
        );
      if (res.Success) {
        this.$toast.success("Başarılı bir şekilde güncellendi.", {
          position: "top",
        });
        this.isContinuityTrackingBulkEvaluation = false;
      } else {
        this.$toast.error("Lütfen zorunlu alanları doldurunuz!.", {
          position: "top",
        });
      }
    },
    async searchFilter(event) {
      
      let tmpData = null;
      tmpData = {
        ...event,
        ...{
          pageSize: this.perPage,
          pageIndex: parseInt(this.currentPage - 1),
          isAdminPage: true,
          loginUserId: this.user.Data.UserId,
        },
      };
      this.searchFilterData = tmpData;
      this.$store.dispatch("suggestion/deleteProductizationData");
      this.$store.dispatch("suggestion/setProductizationData", tmpData);
    },
    orderData(event) {
      sortDate(this.getProductizationData, event);
    },
    async cardDetail(item) {
      this.$store.dispatch("loading/setIsLoading", true);
      this.productizationItem = item;
      this.productizationItem.ProjectPresentationDocumentFiles = [];
      this.productizationItem.DownloadFile = [];

      if (
        this.productizationItem.FileIds &&
        this.productizationItem.FileIds.length > 0
      ) {
        for await (let element of this.productizationItem.FileIds) {
          const res = await upload.fetchDownloadFile(element);
          this.productizationItem.DownloadFile.push({
            DownloadBinary: res.Data.DownloadBinary,
            Extension: res.Data.Extension,
            Filename: res.Data.Filename,
            Id: res.Data.Id,
          });
        }
      }
      if (
        this.productizationItem.ProjectPresentationDocumentIds &&
        this.productizationItem.ProjectPresentationDocumentIds.length > 0
      ) {
        for await (let element of this.productizationItem
          .ProjectPresentationDocumentIds) {
          const res = await upload.fetchDownloadFile(element);
          this.productizationItem.ProjectPresentationDocumentFiles.push({
            DownloadBinary: res.Data.DownloadBinary,
            Extension: res.Data.Extension,
            Filename: res.Data.Filename,
            Id: res.Data.Id,
          });
        }
      }
      this.$store.dispatch("loading/setIsLoading", false);
      this.isProductization = true;
    },
    async downloadExcel() {
      const tmpData = {
        ...this.searchFilterData,
        ...{
          pageSize: this.productizationTotalRecords,
          pageIndex: 0,
        },
      };
      this.isDownloadExcel = true;
      const res = await suggestionRdService.fetchSuggestionRDDownloadExcel(
        tmpData
      );
      const file = `data:image/png;base64,${res.Data.DownloadBinary}`;
      const fileName = `${res.Data.Filename}${res.Data.Extension}`;
      saveAs(file, fileName);
      this.isDownloadExcel = false;
    },
    routeFilterData() {
      const filteredData = this.getProductizationIdData[0];
      const route = lowerCaseKeys(this.$route.query);
      filteredData && route.id ? this.cardDetail(filteredData) : "";
    },
  },
};
</script>